module.exports = __webpack_public_path__ + "static/media/breastfeeding-full.efc4cc1b.png";